module.exports = __webpack_public_path__ + "static/img/6.bf429bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/6.png
// module id = t9Ck
// module chunks = 0